export const GET_FACILITY_REVERSES = 'facility_reverses/GET_FACILITY_REVERSES'
export const ADD_FACILITY_REVERSE = 'facility_reverses/ADD_FACILITY_REVERSE'
export const EDIT_FACILITY_REVERSE = 'facility_reverses/EDIT_FACILITY_REVERSE'
export const SUBMIT_FACILITY_REVERSE = 'facility_reverses/SUBMIT_FACILITY_REVERSE'
export const APPROVE_FACILITY_REVERSE = 'facility_reverses/APPROVE_FACILITY_REVERSE'
export const REJECT_FACILITY_REVERSE = 'facility_reverses/REJECT_FACILITY_REVERSE'
export const DELETE_FACILITY_REVERSE = 'facility_reverses/DELETE_FACILITY_REVERSE'
export const START_LOADING_FACILITY_REVERSE = 'facility_reverses/START_LOADING_FACILITY_REVERSE'
export const STOP_LOADING_FACILITY_REVERSE = 'facility_reverses/STOP_LOADING_FACILITY_REVERSE'
